import styled from "styled-components"

export const Cover = styled.img`
	height: 270px;
	width: 100%;

	object-fit: cover;

	pointer-events: none;
`

export const AboutGallery = styled.div`
	display: flex;
	flex-direction: column;

	width: 100%;
`

export const Header = styled.div`
	padding: 0 24px;
`
